module.exports = __webpack_public_path__ + "static/media/RockyMountains.cc1b0f17.jpg";